const userRoles = {
    PRODUCT_PRO: 'pro',
    PRODUCT_FREE: 'pub',
    PRODUCT_STUDENT: 'student',
};

export default userRoles;
